<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-container>
            <v-card>
                <v-text-title>
                    เชื่อมต่อwebhook
                </v-text-title>
            </v-card>
        </v-container>
      </div>
    </v-main>
  </div>
</template>
<script>
// import axios from 'axios' // api

export default {
  components: {
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  created () {
  },
  data () {
    return {
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/System/connectService.vue